import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  FlatList,
  TouchableOpacity,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useMuteStore } from '../store/muteStore';
import { colors } from '../utils/colors';
import { typography } from '../utils/typography';
import { spacing } from '../utils/theme';

export const MutedUsersScreen: React.FC = () => {
  const { mutedUsers, unmuteUser } = useMuteStore();
  const mutedUsersArray = Array.from(mutedUsers);

  const handleUnmute = (did: string) => {
    unmuteUser(did);
  };

  const renderItem = ({ item }: { item: string }) => (
    <View style={styles.userItem}>
      <View style={styles.userInfo}>
        <Ionicons name="person-circle" size={40} color={colors.textSecondary} />
        <Text style={styles.userDid} numberOfLines={1}>{item}</Text>
      </View>
      <TouchableOpacity
        style={styles.unmuteButton}
        onPress={() => handleUnmute(item)}
      >
        <Text style={styles.unmuteButtonText}>ミュート解除</Text>
      </TouchableOpacity>
    </View>
  );

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.headerTitle}>ミュートしたアカウント</Text>
      </View>

      {mutedUsersArray.length === 0 ? (
        <View style={styles.emptyContainer}>
          <Ionicons
            name="volume-mute-outline"
            size={64}
            color={colors.textSecondary}
          />
          <Text style={styles.emptyText}>ミュートしたアカウントはありません</Text>
        </View>
      ) : (
        <FlatList
          data={mutedUsersArray}
          keyExtractor={item => item}
          renderItem={renderItem}
          contentContainerStyle={styles.listContent}
        />
      )}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  header: {
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
    backgroundColor: colors.background,
  },
  headerTitle: {
    ...typography.h2,
    color: colors.text,
  },
  listContent: {
    padding: spacing.md,
  },
  userItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  userInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    marginRight: spacing.md,
  },
  userDid: {
    ...typography.body,
    color: colors.text,
    marginLeft: spacing.sm,
    flex: 1,
  },
  unmuteButton: {
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    borderRadius: 20,
    backgroundColor: colors.primary,
  },
  unmuteButtonText: {
    ...typography.small,
    color: colors.background,
    fontWeight: '600',
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing.xl,
  },
  emptyText: {
    ...typography.body,
    color: colors.textSecondary,
    marginTop: spacing.md,
    textAlign: 'center',
  },
});
